import { render, staticRenderFns } from "./ActivitiesForm.vue?vue&type=template&id=78fc42b3"
import script from "./ActivitiesForm.vue?vue&type=script&lang=js"
export * from "./ActivitiesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports